import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import {
	CopyToClipboardWrapperComponent
} from '@go-modules/directives/go-clipboard/copy-to-clipboard-wrapper/copy-to-clipboard-wrapper.component';

export const NgxGoClipboardModule = angular.module('NgxGoClipboardModule', [])
	.directive('copyToClipboardWrapper', downgradeComponent({ component: CopyToClipboardWrapperComponent }))
	.name;
